import styled from "styled-components";

export const Base = styled.div(({ theme }) => ({
  paddingTop: theme.spacing.standard,
  paddingLeft: theme.spacing.gutter,
  paddingRight: theme.spacing.gutter,
  height: theme.spacing.base * 26,
}));
